import { Box } from "@mui/material";

interface Props {
    timeRange: "LatestValue" | "Average3h" | "Average24h",
    setTimeRange: (value: "LatestValue" | "Average3h" | "Average24h" ) => void;
}

interface ItemProps {
    children: React.ReactNode;
    isActive: boolean;
    onClick: any;
}

const Item = ({ children, isActive, onClick }: ItemProps) => {
    return (
        <Box
            onClick={onClick}
            sx={{
                p: 1,
                mr: 0.5,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1,
                bgcolor: isActive ? 'grey.300' : 'grey.100',
                cursor: 'pointer',
                '&:hover': {
                    bgcolor: 'grey.400'
                }
            }}
        >
            {children}
        </Box>
    );
};

export function TimeRangeButtons(props: Props): React.JSX.Element {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row'
            }}
        >
            <Item
                isActive={props.timeRange == "LatestValue"}
                onClick={() => {
                    props.setTimeRange("LatestValue")
                }}
            >
                <div>
                    Latest
                </div>
            </Item>
            <Item
                isActive={props.timeRange == "Average3h"}
                onClick={() => {
                    props.setTimeRange("Average3h")
                }}
            >
                <div>
                    Last 3-hr
                </div>
            </Item>
            <Item
                isActive={props.timeRange == "Average24h"}
                onClick={() => {
                    props.setTimeRange("Average24h")
                }}
            >
                <div>
                    Last 24-hr
                </div>
            </Item>
        </Box>
    );
}